import React from "react";
import styles from "./Home.module.css";
import { actions } from "../lib/actions";
import { useStateContext } from "../lib/StateContext";

function Home({ nextPage }) {
  const [_, dispatch] = useStateContext();
  return (
    <section className={styles.home}>
      <h1>Galactic Tycoon</h1>
      <article>
        Inspired by the classic tycoon games of the past, In
        <i>
          <b> Galatic Tycoon </b>
        </i>
        you start as a teenager selling ice-cream and your goal is to make
        enough dongs to start a Galatic Empire.
      </article>
      <div className={styles.nameInput}>
        <input
          className="form-input"
          type="text"
          placeholder="Your Name"
          autoComplete="none"
          onChange={(event) => dispatch(actions.setName(event.target.value))}
        />
        <button
          className="btn btn-primary"
          onClick={() => dispatch(actions.changePage(nextPage))}
        >
          Start
        </button>
      </div>
    </section>
  );
}

export default Home;
